import * as React from 'react';
import { Loader } from '@wix/design-system';
import css from './App.scss';
import { DataHooks } from '../../constants/dataHooks';

export const AppLoader: React.FC = () => (
  <div className={css.loaderOverlay}>
    <Loader dataHook={DataHooks.Loader} />
  </div>
);
